import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HeaderBar } from '../components/HeaderBar';
import { StatusBar } from '../components/StatusBar';
import { ActionButton } from '../components/ActionButton';
import { useNegotiation } from '../context/NegotiationContext';
export const InvitationScreen: React.FC = () => {
  const navigate = useNavigate();
  const {
    hasSubmittedOffer,
    negotiationCompleted,
    selectedTab,
    setSelectedTab
  } = useNegotiation();
  const [showDeclineModal, setShowDeclineModal] = useState(false);
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  // Get current status based on negotiation state
  const getCurrentStatus = () => {
    if (negotiationCompleted) return 'Offer Submitted';
    if (hasSubmittedOffer) return 'Negotiation In Progress';
    return 'Invitation Received';
  };
  const handleAccept = () => {
    setShowAcceptModal(true);
  };
  const confirmAccept = () => {
    setShowAcceptModal(false);
    // Add a small delay for better UX
    setTimeout(() => {
      navigate('/submit-proposal');
    }, 300);
  };
  const handleDecline = () => {
    setShowDeclineModal(true);
  };
  const confirmDecline = () => {
    // Handle decline logic here
    setShowDeclineModal(false);
    // Show a confirmation message
    alert('Thank you for your response. Your decision has been recorded.');
  };
  const handleTabChange = (tab: string) => {
    setSelectedTab(tab);
    // If selecting negotiation tab, navigate to negotiation screen
    if (tab === 'negotiation') {
      navigate('/negotiation');
    }
  };
  return <div className="min-h-screen bg-[#f5f6f8]" data-id="element-180">
      <HeaderBar logoSrc="https://uploadthingy.s3.us-west-1.amazonaws.com/tXtrQ38XxwUBTwmzoNN8ZL/Prospeum_Logo_White_SVG.svg" logoAlt="Prospeum Logo" data-id="element-181" />
      <main className="container mx-auto px-4 py-8" data-id="element-182">
        <div className="flex items-center justify-between mb-6" data-id="element-183">
          <div className="flex items-center" data-id="element-184">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vZynz9GzUii4yVgnqvm17M/image.png" alt="ACME Inc. Logo" className="w-10 h-10 rounded mr-3" data-id="element-185" />
            <h1 className="text-2xl font-bold text-[#333333]" data-id="element-186">
              Sourcing Request from ACME Inc.
            </h1>
          </div>
        </div>
        <StatusBar status={getCurrentStatus()} data-id="element-187" />
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-188">
          <div className="p-6" data-id="element-189">
            <h2 className="text-xl font-bold text-[#333333] mb-4" data-id="element-190">
              Request for Proposal: Business Laptop
            </h2>
            <div className="mb-8" data-id="element-191">
              <div className="border-b border-gray-200" data-id="element-192">
                <nav className="-mb-px flex space-x-8 overflow-x-auto" data-id="element-193">
                  <button className={`py-4 px-1 text-sm font-medium whitespace-nowrap border-b-2 ${selectedTab === 'overview' ? 'border-[#005a9e] text-[#005a9e]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => handleTabChange('overview')} data-id="element-194">
                    Overview
                  </button>
                  {hasSubmittedOffer && <button className={`py-4 px-1 text-sm font-medium whitespace-nowrap border-b-2 ${selectedTab === 'negotiation' ? 'border-[#005a9e] text-[#005a9e]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => handleTabChange('negotiation')} data-id="element-195">
                      Negotiation
                    </button>}
                </nav>
              </div>
              {selectedTab === 'overview' && <div className="py-6" data-id="element-196">
                  <h3 className="text-lg font-medium text-[#333333] mb-3" data-id="element-197">
                    Project Overview
                  </h3>
                  <p className="text-[#333333] mb-4" data-id="element-198">
                    ACME Inc. is seeking proposals for the refresh of our
                    marketing department's laptop fleet. We require 200 business
                    laptops suitable for graphic design, video editing, and
                    marketing analytics.
                  </p>
                  <h3 className="text-lg font-medium text-[#333333] mb-3 mt-6" data-id="element-199">
                    Requirements
                  </h3>
                  <ul className="list-disc pl-5 text-[#333333] mb-4 space-y-2" data-id="element-200">
                    <li data-id="element-201">
                      <strong data-id="element-202">CPU/Processor:</strong> Should provide efficient
                      multitasking, support office productivity software, video
                      conferencing, and light data analysis. A modern multi-core
                      processor (e.g., Intel Core i5/i7 or AMD Ryzen 5/7) is
                      preferred.
                    </li>
                    <li data-id="element-203">
                      <strong data-id="element-204">Screen:</strong> A clear, anti-glare display with
                      Full HD (1920×1080) resolution for comfortable daily use.
                      Screen size between 14–15.6 inches is ideal for balancing
                      productivity and portability.
                    </li>
                    <li data-id="element-205">
                      <strong data-id="element-206">Audio Device:</strong> Integrated speakers and
                      microphone suitable for video calls and online meetings,
                      with noise-cancellation support recommended. A headphone
                      jack and Bluetooth audio support are desirable.
                    </li>
                    <li data-id="element-207">
                      <strong data-id="element-208">Memory Space (RAM & Storage):</strong> At least 16
                      GB RAM for smooth multitasking and a minimum of 512 GB SSD
                      storage for fast boot-up, quick file access, and adequate
                      storage of business documents and applications.
                    </li>
                    <li data-id="element-209">
                      <strong data-id="element-210">Size and Weight:</strong> Slim and lightweight
                      design to support portability for travel and commuting.
                      Target weight: 1.2–1.8 kg. Thickness: less than 20 mm
                      preferred.
                    </li>
                    <li data-id="element-211">
                      <strong data-id="element-212">Warranty:</strong> A minimum of 3 years warranty
                      covering parts and labor. On-site or next-business-day
                      support preferred for reduced downtime.
                    </li>
                  </ul>
                  <h3 className="text-lg font-medium text-[#333333] mb-3 mt-6" data-id="element-213">
                    Target Date
                  </h3>
                  <p className="text-[#333333] mb-4" data-id="element-214">30.09.2025</p>
                  <h3 className="text-lg font-medium text-[#333333] mb-3 mt-6" data-id="element-215">
                    Documents
                  </h3>
                  <div className="border border-gray-200 rounded-md p-4 bg-[#f5f6f8]" data-id="element-216">
                    <div className="flex items-center mb-2" data-id="element-217">
                      <svg className="w-5 h-5 text-[#005a9e] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-218">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" data-id="element-219" />
                      </svg>
                      <a href="#" className="text-[#005a9e] hover:underline" data-id="element-220">
                        Download RFP Document.pdf
                      </a>
                    </div>
                    <div className="flex items-center" data-id="element-221">
                      <svg className="w-5 h-5 text-[#005a9e] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-222">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" data-id="element-223" />
                      </svg>
                      <a href="#" className="text-[#005a9e] hover:underline" data-id="element-224">
                        Technical Requirements.xlsx
                      </a>
                    </div>
                  </div>
                </div>}
              {selectedTab === 'negotiation' && <div className="py-6" data-id="element-225">
                  <div className="bg-[#f5f6f8] rounded-lg p-6 mb-6 border border-gray-200" data-id="element-226">
                    <h3 className="text-lg font-medium text-[#333333] mb-4 flex items-center" data-id="element-227">
                      <svg className="w-5 h-5 mr-2 text-[#005a9e]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-228">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" data-id="element-229" />
                      </svg>
                      Proposal Summary
                    </h3>
                    <div className="space-y-3" data-id="element-230">
                      <div className="flex justify-between py-2 border-b border-gray-200" data-id="element-231">
                        <span className="text-[#333333] font-medium" data-id="element-232">
                          Status:
                        </span>
                        <span className="px-3 py-1 rounded-full text-sm font-medium bg-[#4caf50] bg-opacity-10 text-[#4caf50]" data-id="element-233">
                          {negotiationCompleted ? 'Revised Proposal Submitted' : 'Submitted to Buyer'}
                        </span>
                      </div>
                      <div className="flex justify-between py-2 border-b border-gray-200" data-id="element-234">
                        <span className="text-[#333333] font-medium" data-id="element-235">
                          Total Cost:
                        </span>
                        <span className="text-[#333333] font-bold" data-id="element-236">
                          {negotiationCompleted ? '$137,250' : '$180,000'}
                          {negotiationCompleted && <span className="ml-2 text-xs text-green-600 line-through" data-id="element-237">
                              $180,000
                            </span>}
                        </span>
                      </div>
                      {negotiationCompleted && <div className="flex justify-between py-2 border-b border-gray-200" data-id="element-238">
                          <span className="text-[#333333] font-medium" data-id="element-239">
                            Discount Applied:
                          </span>
                          <span className="text-green-600 font-medium" data-id="element-240">
                            23.75%
                          </span>
                        </div>}
                      <div className="flex justify-between py-2 border-b border-gray-200" data-id="element-241">
                        <span className="text-[#333333] font-medium" data-id="element-242">
                          Submission Date:
                        </span>
                        <span className="text-[#333333]" data-id="element-243">Today</span>
                      </div>
                      <div className="flex justify-between py-2 border-b border-gray-200" data-id="element-244">
                        <span className="text-[#333333] font-medium" data-id="element-245">
                          Next Steps:
                        </span>
                        <span className="text-[#333333]" data-id="element-246">
                          Awaiting buyer review
                        </span>
                      </div>
                    </div>
                    <div className="mt-6" data-id="element-247">
                      <ActionButton label="View Negotiation Details" onClick={() => navigate('/negotiation')} className="w-full" data-id="element-248" />
                    </div>
                  </div>
                  <div className="bg-[#f5f6f8] rounded-lg p-6 border border-gray-200" data-id="element-249">
                    <h3 className="text-lg font-medium text-[#333333] mb-4 flex items-center" data-id="element-250">
                      <svg className="w-5 h-5 mr-2 text-[#005a9e]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-251">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" data-id="element-252" />
                      </svg>
                      Timeline
                    </h3>
                    <div className="space-y-4" data-id="element-253">
                      <div className="flex" data-id="element-254">
                        <div className="flex-shrink-0" data-id="element-255">
                          <div className="h-4 w-4 rounded-full bg-green-500 mt-1" data-id="element-256"></div>
                        </div>
                        <div className="ml-3" data-id="element-257">
                          <p className="text-sm font-medium text-gray-900" data-id="element-258">
                            Proposal Submitted
                          </p>
                          <p className="text-xs text-gray-500" data-id="element-259">
                            Today, 10:30 AM
                          </p>
                        </div>
                      </div>
                      {negotiationCompleted && <div className="flex" data-id="element-260">
                          <div className="flex-shrink-0" data-id="element-261">
                            <div className="h-4 w-4 rounded-full bg-green-500 mt-1" data-id="element-262"></div>
                          </div>
                          <div className="ml-3" data-id="element-263">
                            <p className="text-sm font-medium text-gray-900" data-id="element-264">
                              Revision Submitted
                            </p>
                            <p className="text-xs text-gray-500" data-id="element-265">
                              Today, 10:45 AM
                            </p>
                          </div>
                        </div>}
                      <div className="flex" data-id="element-266">
                        <div className="flex-shrink-0" data-id="element-267">
                          <div className="h-4 w-4 rounded-full bg-gray-300 mt-1" data-id="element-268"></div>
                        </div>
                        <div className="ml-3" data-id="element-269">
                          <p className="text-sm font-medium text-gray-500" data-id="element-270">
                            Buyer Review
                          </p>
                          <p className="text-xs text-gray-500" data-id="element-271">Pending</p>
                        </div>
                      </div>
                      <div className="flex" data-id="element-272">
                        <div className="flex-shrink-0" data-id="element-273">
                          <div className="h-4 w-4 rounded-full bg-gray-300 mt-1" data-id="element-274"></div>
                        </div>
                        <div className="ml-3" data-id="element-275">
                          <p className="text-sm font-medium text-gray-500" data-id="element-276">
                            Award Decision
                          </p>
                          <p className="text-xs text-gray-500" data-id="element-277">Pending</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>}
            </div>
            {!hasSubmittedOffer && <div className="flex flex-col sm:flex-row justify-end space-y-3 sm:space-y-0 sm:space-x-4 mt-8" data-id="element-278">
                <ActionButton label="Decline to Bid" onClick={handleDecline} variant="ghost" data-id="element-279" />
                <ActionButton label="Accept & Create Proposal" onClick={handleAccept} data-id="element-280" />
              </div>}
          </div>
        </div>
      </main>
      {/* Accept Confirmation Modal */}
      {showAcceptModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-281">
          <div className="bg-white rounded-lg p-6 max-w-md w-full" data-id="element-282">
            <h3 className="text-lg font-bold text-[#333333] mb-4" data-id="element-283">
              Confirm Acceptance
            </h3>
            <p className="text-[#333333] mb-6" data-id="element-284">
              By accepting this invitation, you agree to submit a proposal
              according to the requirements and timeline specified. Would you
              like to proceed?
            </p>
            <div className="flex justify-end space-x-4" data-id="element-285">
              <ActionButton label="Cancel" onClick={() => setShowAcceptModal(false)} variant="ghost" data-id="element-286" />
              <ActionButton label="Yes, Accept" onClick={confirmAccept} variant="primary" data-id="element-287" />
            </div>
          </div>
        </div>}
      {/* Decline Confirmation Modal */}
      {showDeclineModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-288">
          <div className="bg-white rounded-lg p-6 max-w-md w-full" data-id="element-289">
            <h3 className="text-lg font-bold text-[#333333] mb-4" data-id="element-290">
              Confirm Decline
            </h3>
            <p className="text-[#333333] mb-6" data-id="element-291">
              Are you sure you want to decline this sourcing request? This
              action cannot be undone.
            </p>
            <div className="flex justify-end space-x-4" data-id="element-292">
              <ActionButton label="Cancel" onClick={() => setShowDeclineModal(false)} variant="ghost" data-id="element-293" />
              <ActionButton label="Yes, Decline" onClick={confirmDecline} variant="secondary" data-id="element-294" />
            </div>
          </div>
        </div>}
    </div>;
};